import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'font-bold tracking-wide transition-all duration-300 relative overflow-hidden';
  const variants = {
    primary: 'bg-[var(--forge-lava)] text-white hover:bg-[var(--forge-lava-glow)] shadow-lg shadow-[var(--forge-lava)]/20 hover:shadow-xl hover:shadow-[var(--forge-lava)]/30',
    secondary: 'bg-transparent border-2 border-[var(--forge-lava)] text-[var(--forge-lava)] hover:bg-[var(--forge-lava)] hover:text-white',
    ghost: 'bg-transparent text-[var(--forge-white)] hover:text-[var(--forge-lava)]'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-12 py-4 text-lg'
  };
  return <motion.button type={type} onClick={onClick} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-8">
      <span className="relative z-10" data-id="element-9">{children}</span>
    </motion.button>;
}